import { IGlobalSearchResponse } from "@src/types/api/global-search";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { AxiosResponse } from "axios";
import { TResponse } from "@src/types/common";



export async function fetchGlobalSearch(search: string): Promise<AxiosResponse<TResponse<IGlobalSearchResponse>>> {
  return axios.get<TResponse<IGlobalSearchResponse>>(API_ENDPOINTS.GLOBAL_SEARCH, { params: { search } });
};

